import { PROFESSIONS_PATH, SCHOOLS_PATH } from "../../../constants/RoutesConstants";

import Icon from "../ui/Icon";
import LogoContainer from "../LogoContainer";
import MinorLogoContainer from "../MinorLogoContainer";
import React from "react";
import styled from "styled-components";
import useHistoryPush from "../../../hooks/useHistoryPushPreventUnlogged";

const HomeContainer = () => {
    const pushToProfessions = useHistoryPush(PROFESSIONS_PATH);
    const pushToSchools = useHistoryPush(SCHOOLS_PATH);
    return (
        <Container>
            <LogoContainer />
            <Wrapper>
                <Side>
                    <Circle onClick={() => pushToProfessions()}>
                        <Icon name="briefcase" />
                        <span>Profili professionali</span>
                    </Circle>
                </Side>
                <Side>
                    <Circle onClick={() => pushToSchools()}>
                        <Icon name="university" />
                        <span>Informativa</span>
                    </Circle>
                </Side>
            </Wrapper>
            <MinorLogoContainer />
        </Container>
    );
};

export default HomeContainer;

const Container = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${props => props.theme.colors.primary(1)};
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    flex-direction: column;
    /*new*/
    width: 100%;
    height: auto;
    right: inherit;
    bottom: inherit;
    min-height: 100vh;
`;
const Wrapper = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 50rem;
    width: 100%;
`;
const Side = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    /*new*/
    max-width: 100%;
    min-height: 70vh;
    padding: 2rem 0;
`;
const Circle = styled.button`
    width: 70%;
    border: none;
    background-color: ${props => props.theme.colors.white(1)};
    color: ${props => props.theme.colors.black(1)};
    height: 0;
    padding-bottom: 70%;
    outline: none;
    border-radius: 100%;
    cursor: pointer;
    transition: transform 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    box-shadow: 0px 3px 1px -2px ${props => props.theme.colors.black(0.2)}, 0px 2px 2px 0px ${props => props.theme.colors.black(0.14)},
        0px 1px 5px 0px ${props => props.theme.colors.black(0.12)};
    &:hover {
        transform: scaleX(1.5) scaleY(1.5);
        box-shadow: 0px 2px 4px -1px ${props => props.theme.colors.black(0.2)}, 0px 4px 5px 0px ${props => props.theme.colors.black(0.14)},
            0px 1px 10px 0px ${props => props.theme.colors.black(0.12)};
    }
    i {
        font-size: 5rem;
        position: absolute;
        left: 50%;
        top: 20%;
        transform: translateX(-50%);
    }
    span {
        font-size: 1.2rem;
        position: absolute;
        left: 50%;
        bottom: 30%;
        transform: translateX(-50%);
    }
`;
